const targetNode = document.body;

const config = { attributes: false, childList: true, subtree: true };

const callback = function (mutationsList, observer) {
    for (let mutation of mutationsList) {
        if (mutation.type === 'childList') {
            mutation.addedNodes.forEach(node => {
                
                if (node.nodeType === 1 && node.classList.contains('cf-form-inner')) { 

                    document.querySelectorAll('.cf-field').forEach(item => {
                        item.querySelector('input, textarea').addEventListener('focus', () => {
                            item.classList.add('cf-focused');
                        });
                        item.querySelector('input, textarea').addEventListener('blur', () => {
                            if (item.querySelector('input, textarea').value === '') {
                                item.classList.remove('cf-focused');
                            }
                        });
                    });
                }
            });
        }
    }
};

const observer = new MutationObserver(callback);

observer.observe(targetNode, config);

// Later, you can stop observing
// observer.disconnect();
